<template>
    <div v-if="custom_error.state" class="error-notification">
        <div class="error-notification--text">{{ custom_error.text }}</div>
        <div class="error-notification--close" @click="clearError">Скрыть</div>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'

export default {
    name: 'ErrorNotification',
    computed: {
        ...mapGetters(['custom_error'])
    },
    methods: {
        ...mapMutations(['SET_CUSTOM_ERROR']),
        clearError() {
            this.SET_CUSTOM_ERROR({state: false, text: ''})
        }
    }
}
</script>

<style lang="scss" scoped>
    .error-notification {
        display: flex;
        position: fixed;
        right: 20px;
        top: 50px;
        width: 300px;
        height: fit-content;
        background: rgb(128, 51, 51);
        color: #fff;
        box-sizing: border-box;
        padding: 15px;
        border-radius: 13px;
        flex-direction: column;
        gap: 15px;
        &--text {
            display: flex;
            width: 100%;
            color: #fff;
            font-size: 13px;
        }
        &--close {
            display: flex;
            width: 100%;
            color: #a3a1a1;
            font-size: 13px;
            cursor: pointer;
            &:hover {
                text-decoration: underline;
                color: #fff;
            }
        }
    }
</style>